<template>
  <div>
    {{ $t(`experience.${experience}`) }}
  </div>
</template>

<script>
export default {
  name: 'VacancyExperience',
  props: {
    experience: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
experience: Experience
experience.beginner: Without experience
experience.1-3 years: 1-3 years
experience.3-6 years: 3-6 yars
experience.6+ years: 6+ years
</i18n>

<i18n locale="ru" lang="yaml">
experience: Опыт работы
experience.beginner: Начало карьеры
experience.1-3 years: 1-3 года
experience.3-6 years: 3-6 лет
experience.6+ years: Более 6 лет
</i18n>
